import { render, staticRenderFns } from "./EmbeddedNewDocumentEditView.vue?vue&type=template&id=b9cd5908&scoped=true&"
import script from "./EmbeddedNewDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedNewDocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedNewDocumentEditView.vue?vue&type=style&index=0&id=b9cd5908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cd5908",
  null
  
)

export default component.exports